
let FaqCategoryService = function (Restangular) {
  const ServiceAPI = Restangular.all('categories');

    let getFaqList = () => {
      return ServiceAPI.customGET();
    }

    let save = (resource) => {
      if (resource.save) {
        return Restangular.all('admin/categories').customPUT({name: resource.name}, resource.id);
      } else {
          return Restangular.all('admin/categories').post(resource);
      }
    }

    let saveSubCategory = (categoryId, subCategoryName) => {
      return Restangular.all('admin/categories').customPOST({name: subCategoryName}, `${categoryId}/sub`);
    };

    let updateSubCategory = (subCategoryId, subCategoryName) => {
      return Restangular.all('admin/categories').customPUT({name: subCategoryName}, `${subCategoryId}/sub`);
    };

    let deleteCategory = (id) => {
      return Restangular.all('admin/categories').customDELETE(id);
    }

    let deleteSubCategory = (id) => {
      return Restangular.all('admin/categories').customDELETE(`${id}/sub`);
    }

    let index = (query) => {
      query = query || {};
      query.deleted_at = 'null';
      return ServiceAPI.getList(query);
    }

    let load = (query) => {
      return new Promise((resolve, reject) => {
        getFaqList(query)
          .then(response => {
              let count = response[0];
              index(query)
              .then(data => {
                  resolve({count, data});
              })
              .catch(err => {
                  reject(err);
              });
          })
          .catch(err => {
              reject(err);
          });
      });
    }

    load(null)

    let show = (id) => {
      return ServiceAPI.get(id);
    }

    let destroy = (resource) => {
      resource.deleted_at = moment();
      return resource.save();
    }

    return { index, load, save, deleteCategory, show, destroy, saveSubCategory, updateSubCategory, deleteSubCategory } ;
};

FaqCategoryService.$inject = ['Restangular'];

export default FaqCategoryService;



// WEBPACK FOOTER //
// ./client/app/components/categories-faq/categories.service.js